<template>
  <div class="pc-lecture-video">
    <h2>课程视频管理</h2>
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <El-button v-if="isEditting" @click="edit()" class="edit-btn"
      >完成</El-button
    >

    <ul class="pc-lecture-video-list">
      <li class="video-item" v-for="(item, index) in videoList" :key="index">
        <div class="video-item-left" v-if="item.video != null">
          <img
            src="../../../../../static/loading.gif"
            v-if="item.isUploadingVideo"
            alt=""
          />
          <video v-else controls :src="item.video"></video>
        </div>
        <div class="video-item-right">
          <div class="video-content">
            <div class="video-image">
              <img
                v-if="!item.isEdittingVideo && item.cover_image"
                :src="item.cover_image"
                alt=""
              />
              <img
                v-if="!item.isEdittingVideo && !item.cover_image"
                src="../../../../../static/image/no-img.png"
                alt=""
              />
              <UploadImage
                v-if="item.isEdittingVideo && isEditting"
                :img="item.cover_image"
                :width="200"
                :height="120"
                @getUploadImage="getUploadVideoImage($event, item, index)"
                class="upload-image"
              ></UploadImage>
            </div>
            <div class="video-introduction">
              <div class="title">
                <h4>标题</h4>
                <span v-if="!item.isEdittingVideo">{{ item.title }}</span>
                <el-input
                  v-if="item.isEdittingVideo && isEditting"
                  v-model="item.title"
                  placeholder="视频文件名称"
                ></el-input>
              </div>
              <div class="description">
                <h4>介绍</h4>
                <span v-if="!item.isEdittingVideo">{{ item.introduce }}</span>
                <el-input
                  type="textarea"
                  v-if="item.isEdittingVideo && isEditting"
                  v-model="item.introduce"
                  placeholder="视频文件名称"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="video-caption">
            <div class="caption">字幕文件: <span>已上传(开发中)</span></div>
            <div class="process" v-if="!item.isEdittingVideo">
              <span>翻译进度(开发中): </span>
              <el-progress
                :width="100"
                :percentage="100"
                class="process-bar"
              ></el-progress>
            </div>
            <div class="update" @click="editVideo(index, item)">
              <p v-if="!item.isEdittingVideo && isEditting">修改</p>
              <UploadVideo
                v-if="item.isEdittingVideo && isEditting"
                @getUploadVideo="getUploadVideo($event, item)"
                @startUploadVideo="startUploadVideo(item, index)"
              ></UploadVideo>
              <p
                v-if="item.isEdittingVideo && isEditting"
                @click="deleteShow(index)"
              >
                删除
              </p>
              <p
                v-if="item.isEdittingVideo && isEditting"
                @click="changeVideo(item)"
              >
                确认
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div @click="addVideo()" class="add-btn" v-show="isEditting">
      <span>添加</span>
    </div>
    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";
import UploadVideo from "./UploadVideo.vue";
import UploadImage from "../../../componentSet/uploadImage.vue";

import {
  getLectureVideo_Api,
  updateLectureVideo_Api,
  addLectureVideo_Api,
  deleteLectureVideo_Api,
} from "../../../../apis/lecture.api";
export default {
  data() {
    return {
      isEditting: false,
      deleteDialogVisible: false,
      videoList: [],
      lecture_id: null,
      delete_index: null,
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.lecture_id = this.$route.query.id;
      this.getLectureVideo();
    }
  },
  components: {
    UploadVideo,
    UploadImage,
    DeleteDialog,
  },
  methods: {
    async edit() {
      this.isEditting = !this.isEditting;
      if (!this.isEditting) {
        this.videoList.forEach((item) => {
          item.isEdittingVideo = false;
        });
         await this.getLectureVideo()
        this.$global.success(this, "获取成功");
      }
      
    
    },
    addVideo() {
      this.videoList.push({
        method: "add",
        isEdittingVideo: true,
        video: "",
        cover_image: null,
        title: "",
        introduce: "",
      });
    },
    getUploadVideoImage(data, item, index) {
      item.cover_image = data;
      this.$set(this.videoList, index, item);
    },
    startUploadVideo(item, index) {
      item.isUploadingVideo = true;
      this.$set(this.videoList, index, item);
    },
    getUploadVideo(data, item, index) {
      item.isUploadingVideo = false;
      item.video = data;
      this.$set(this.videoList, index, item);
      console.log(item, data);
    },
    editVideo(index, item) {
      item.isEdittingVideo = true;
      this.$set(this.videoList, index, item);
    },
    getLectureVideo() {
      getLectureVideo_Api(this.lecture_id).then((res) => {
        this.videoList = res.data;
        this.videoList.forEach((item) => {
          item.method = "update";
          item.isEdittingVideo = false;
          item.isUploadingVideo = false;
        });
        console.log(this.videoList);
      });
    },
    deleteConfirm() {
      console.log(this.videoList[this.delete_index]);
      // this.
      let video_id = this.videoList[this.delete_index].id;
      if (video_id) {
        deleteLectureVideo_Api({ video_id: video_id })
          .then((res) => {
            this.$global.success(this, "删除成功");
            this.getLectureVideo();
            this.deleteDialogVisible = false;
          })
          .catch(() => {
            this.$global.error(this, "删除失败, 请重试");
          });
      } else {
        this.videoList.splice(this.delete_index, 1);
        this.deleteDialogVisible = false;
      }
    },
    closeDelete() {
      console.log(1324132);
      this.deleteDialogVisible = false;
    },
    deleteShow(index) {
      this.delete_index = index;
      this.deleteDialogVisible = true;
    },
    changeVideo(item) {
      console.log(item);
      if (!item.video) {
        this.$global.error(this, "请上传视频");
      }
      if (item.update_time) {
        delete item.update_time;
      }
      if (item.id) {
        item.video_id = item.id;
      }
      if (item.method == "update") {
        updateLectureVideo_Api(item)
          .then((res) => {
            // this.getLectureVideo();
            console.log(res);
            this.$global.success(this, "更新成功");
            item.isEdittingVideo = false;
          item.isUploadingVideo = false;

          })
          .catch(() => {
            this.$global.error(this, "更新失败");
          });
      } else {
        item.lecture_id = this.$route.query.id;
        addLectureVideo_Api(item)
          .then((res) => {
            // this.getLectureVideo();
            this.$global.success(this, "添加成功");
            item.isEdittingVideo = false;
          item.isUploadingVideo = false;
          })
          .catch(() => {
            this.$global.error(this, "添加失败");
          });
      }

      console.log(item);
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-lecture-video {
  @include box-model;
  .edit-btn {
    right: 30px;
  }
  .pc-lecture-video-list {
    width: 100%;
    .video-item {
      display: flex;
      width: 100%;
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px $timeBtn dashed;
      .video-item-left {
        position: relative;
        width: 285px !important;
        height: 160px;
        border: 1px solid #979797;
        margin-right: 20px;
        video {
          width: 285px;
          height: 160px;
        }
        img {
          width: 285px;
          height: 160px;
        }
      }
      .video-item-right {
        width: calc(100% - 285px);
        position: relative;
        .video-content {
          display: flex;
          .video-image {
            img {
              width: 220px;
              height: 133px;
            }
            .upload-image {
              margin-right: 25px;
              margin-bottom: 15px;
            }
          }
          .video-introduction {
            width: 100%;
            .title {
              margin-bottom: 10px;
            }
            .title,
            .description {
              display: flex;
              h4 {
                flex-shrink: 0;
                font-size: 14px;
                width: 50px;
                font-weight: 600;
                text-align: right;
                margin-right: 20px;
                align-self: center;
                display: flex;
                justify-content: flex-end;
              }
              span {
                font-size: 14px;
              }
            }
          }
        }
        .video-caption {
          margin-top: 10px;
          display: flex;
          font-size: 12px;
          align-items: flex-start;
          .caption {
            width: 220px;
            font-size: 12px;
            margin-right: 20px;
          }
          .process {
            display: flex;
            width: 400px;
            .process-bar {
              width: 300px;
            }
          }
          .update {
            line-height: 20px;
            text-align: center;
            border-radius: 5px;
            cursor: pointer;
            display: flex;
            margin-left: auto;
            background: $base-color;
            p {
              border: 1px $timeBtn dashed;
              width: 60px;
              height: 20px;
              color: $timeBtn;
              margin-left: 10px;
            }
            p:hover {
              background: $timeBtn;
              color: $base-color;
            }
          }
        }
      }

      .video-item-bottom {
        font-size: 14px;
        width: 80%;
        min-width: 700px;
        color: #434343;
        line-height: 21px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h4 {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #434343;
          line-height: 21px;
        }
        /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
          background-color: #409eff;
          border-color: #409eff;
        }
        /deep/
          .el-checkbox__input.is-disabled.is-checked
          .el-checkbox__inner::after {
          border-color: #fff;
        }
        /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
          color: #000;
        }
        /deep/ .el-input__inner {
          width: 90%;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
        }
        /deep/ .el-input:first-of-type {
          margin-top: 0px;
        }
        /deep/ .el-input {
          margin-bottom: 10px;
        }
        textarea {
          width: 90%;
          height: 60px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          padding-left: 15px;
          outline-color: #dcdfe6;
          resize: none;
        }
        /deep/ input:-ms-input-placeholder,
        /deep/ textarea:-ms-input-placeholder {
          color: #999999;
        }
        /deep/ input::-webkit-input-placeholder,
        /deep/ textarea::-webkit-input-placeholder {
          color: #999999;
        }
        p {
          margin-top: 10px;
          width: 1200px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #434343;
          line-height: 21px;
        }
        .pc-video-content-bottom-subtitle {
          display: flex;
          span {
            display: inline-block;
            width: 100px;
            height: 26px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #dcdfe6;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 30px;
            // text-align: center;
            strong {
              // width: 48px;
              margin-left: 11px;
              font-size: 12px;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5470c6;
              line-height: 12px;
              text-align: left;
            }
            i {
              display: inline-block;
              margin-top: -1px;
              // margin-right: -16px;
              // margin-left: 11px;
              width: 19px;
              height: 26px;
              background: #dcdfe6;
              border-radius: 4px;
              border: 1px solid #dcdfe6;
              color: #5470c6;
              text-align: right;
            }

            /deep/ .icon-zhuanhuan:before {
              font-size: 10px;
            }
            /deep/ .icon-shangchuanicon:before {
              font-size: 10px;
            }
          }
          /deep/ .el-upload--text {
            width: 100px;
            display: flex;
            justify-content: space-between;
            i {
              margin-top: 0;
              border-radius: 0 4px 4px 0 !important;
              display: inline-block;
              text-align: center;
            }
          }
          /deep/ .el-button--mini {
            // border-radius: 4px 0 0 4px !important;
            border: none;
            margin-left: 11px;
            margin-top: 1px;

            height: 24px;
            padding: 0;
            text-align: center;
            line-height: 26px;
          }
          /deep/ .el-button--primary {
            background-color: #fff;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #646464;
            font-size: 12px;
          }
        }
      }
      .video-item-position {
        width: 40px;
        height: 100px;
        text-align: center;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 20px;
        display: none;
        p {
          margin-bottom: 10px;
        }
        .pc-video-position-top {
          margin-top: 15px;
          // margin-bottom: 21px;
        }
      }
    }
  }
  .add-btn {
    width: 110px;
    height: 40px;
    margin-top: 40px;
    margin-bottom: 40px;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    border: 1px #5470c6 dashed;
    span {
      font-size: 14px;
      text-align: center;
      color: #5470c6;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/lecture/components/LectureVideo.vue